import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
//IMPORTACION DE RUTAS
import { ROUTES } from './app.routes';
import { HomeModule } from './pages/home/home.module';
import { CasillaActualService } from './services/casilla-actual.service';
import { UsuariosService } from './services/usuarios.service';
import { JwtModule } from "@auth0/angular-jwt";
import { AuthInterceptor } from './Interceptors/auth-interceptor';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { AlertComponent } from './shared/components/alert/alert.component';
import { MatSnackBarModule, MatDialogModule, MatIconModule, MatProgressSpinnerModule, MatButtonModule, MatTooltipModule } from '@angular/material';
import { BaseButtonComponent } from './shared/components/buttons/buttton/base-button.component';
import { ClickStopPropagation } from './directives/click-stop-propagation.directive';
import { LoginModule } from './pages/login/login.module';

const KEYSTORAGE_SESSION = "PROVIAS_SESION_ACTUAL";

export function tokenGetter() {
  const token = localStorage.getItem(KEYSTORAGE_SESSION);
  console.log('token', token);
  return token;
}

@NgModule({
  declarations: [
    AppComponent,
    AlertComponent,
    BaseButtonComponent,
    ClickStopPropagation
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    RouterModule,
    RouterModule.forRoot( ROUTES, { useHash: false } ),
    HomeModule,
    LoginModule,
    ReactiveFormsModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          const token = localStorage.getItem(KEYSTORAGE_SESSION);
          return token;
        }
      }      
    }),
    NoopAnimationsModule,
    MatSnackBarModule,
    MatDialogModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatTooltipModule
  ],
  entryComponents: [
    AlertComponent
  ],
  providers: [
    UsuariosService,
    CasillaActualService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent] 
})
export class AppModule { }
